import request from '@/utils/request'

/**
 * 提交官网留言（公开接口，无需登录）。
 * 环海调用时 siteType 传 1。
 */
export function addGuestMessage(data) {
  return request({
    url: '/service/guestMessage/addGuestMessage',
    method: 'post',
    timeout: 15000,
    data
  })
}
